// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uWZM","label":"styles_label__3hNRc"};